module.exports = __webpack_public_path__ + "static/media/folder-times.39299c6e.svg";